import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "../../api/constant";
import type {
    holiday,
    holidayResponse,
    holidayByIdResponse,
} from "@/interface/holiday.interface";

export const HolidayService = {
    createHoliday: async (
        payload: holiday,
    ): Promise<holidayResponse> => {
        const API = `${API_ENDPOINT?.holiday}`;
        return callApi<holidayResponse>(API, { method: "POST", data: payload });
    },



    getHoliday: async (
        params?: string,
        signal?: AbortSignal,
    ): Promise<holidayResponse> => {
        const API = `${API_ENDPOINT?.holiday}${params ? `?${params}` : ""}`;
        return callApi<holidayResponse>(API, { method: "GET", signal });
    },

    updateHoliday: async (
        payload: holiday,
        id: string,
    ): Promise<holidayResponse> => {
        const API = `${API_ENDPOINT?.holiday}/${id}`;
        return callApi<holidayResponse>(API, { method: "PUT", data: payload });
    },

    deleteHoliday: async (id: string): Promise<holidayResponse> => {
        const API = `${API_ENDPOINT?.holiday}/${id}`;
        return callApi<holidayResponse>(API, { method: "DELETE" });
    },

    getHolidayById: async (id: string): Promise<holidayByIdResponse> => {
        const API = `${API_ENDPOINT?.holiday}/${id}`;
        return callApi<holidayByIdResponse>(API, { method: "GET" });
    },
};
